<template>
    <div class="page-content-wrapper">
        <div class="content">
            <div class="container-fluid">
                <div class="row p-3">
                    <div class="col-lg-12">
                        <h2 class="text-dag">Dashboard</h2>
                    </div>
                </div>

                <div v-for="chart in getDashboard"
                     class="card no-border">
                    <div class="card-body">

                        <b>{{ chart.Title }}</b><br>
                        {{chart.Description}}

                        <GChart
                            type="AreaChart"
                            :data="chart.chartData"
                            :options="chartOptions"
                        />
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import { GChart } from 'vue-google-charts'
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  name: 'Dashboard',
  components: { GChart },
  computed: {
    ...mapGetters([
      'getDashboard',
    ]),
  },
  data () {
    return {
      /*multiChartData: [
        {
          Title: 'Chart title 1',
          chartData: [
            ['Year', 'Data'],
            ['01-01-2018', 10],
            ['02-01-2018', 20],
            ['03-01-2018', 30],
            ['04-01-2018', 40],
            ['05-01-2018', 50],
            ['06-01-2018', 60],
            ['07-01-2018', 70],
            ['08-01-2018', 80],
            ['09-01-2018', 90],
            ['10-01-2018', 100]
          ]
        },
        {
          Title: 'Chart title 2',
          chartData: [
            ['Year', 'Data'],
            ['01-01-2019', 5],
            ['02-01-2019', 10],
            ['03-01-2019', 35],
            ['04-01-2019', 5],
            ['05-01-2019', 25],
            ['06-01-2019', 30],
            ['07-01-2019', 15],
            ['08-01-2019', 40],
            ['09-01-2019', 45],
            ['10-01-2019', 25]
          ]
        },
      ]*/
      chartOptions: {
        legend: {position: 'none'},
        colors: ['#3A86FF']
      }
    }
  },
  methods: {
    ...mapActions([
      'loadDashboard',
    ]),
  },
  created() {
    this.loadDashboard();
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue